module.exports = __webpack_public_path__ + "img/BannerImage.6d0bd2e9.jpg";